<template>
  <div class="malden-simple-header container mx-auto py-8 text-center">
    <img src="/img/malden-catholic-wordmark.svg" width="300px" height="auto" alt="Malden Catholic">
    <h2 class="text-white text-xl  font-hairline" style="height: 0; overflow: hidden;">
        Malden Catholic
    </h2>
  </div>
</template>

<script>
export default {
  name: "maldenSimpleHeader"
};
</script>
